import React from 'react';
import { Box, CircularProgress } from '@mui/material';

type Props = {
  widgetHeight?: number;
};
const LoaderSmall: React.FC<Props> = ({ widgetHeight }) => {
  return (
    <Box
      data-testid='bxCirculer'
      sx={{
        height: `${widgetHeight ? widgetHeight : 100}px`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress
        style={{
          width: '24px',
          height: '24px',
        }}
      />
    </Box>
  );
};

export default LoaderSmall;
